$(document).ready(function(){
  $(".owl-carousel").owlCarousel({
      items:1,
      loop:true,
      dots: true,
      margin:0,
      autoplay:true,
      autoplayTimeout:8000,
      autoplayspeed: 20000,
      smartSpeed: 3000,
      autoplayHoverPause:true
  });
});
